/**
 * NoBid - PrebidJS Adapter
 * Handles header bidding with Amazon
 * version 1.0.1
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdBidders/adapters/nobid',[
    "jquery",
    "logging"
], function($, logging) {
    "use strict";
    var _ModuleName = "NoBid";

    var _config = { }

    var _initialized = false;
    var init = function(config) {
        if (!_initialized) {
            $.extend(_config, config);
            _initialized = true;
        }
    }

    var getBidDefinition = function(slot) {
        // make sure we're initialized
        if (!_initialized) { return ; }

        ;
        
        // build definition
        var definition = $.extend({}, {
            bidder: _config.name,
            params: {
                siteId: _config.siteId
            }
        });

        return definition;
    }

    var getBidderSettings = function() {
        return { }
    }

    return {
        name: _ModuleName,
        init: init,
        getBidDefinition: getBidDefinition,
        getBidderSettings: getBidderSettings
    }
});
